import { render } from "./GoldFrame.vue?vue&type=template&id=7b20294a&scoped=true&ts=true"
import script from "./GoldFrame.vue?vue&type=script&lang=ts"
export * from "./GoldFrame.vue?vue&type=script&lang=ts"

import "./GoldFrame.vue?vue&type=style&index=0&id=7b20294a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b20294a"]])

export default __exports__